// extracted by mini-css-extract-plugin
export default {"header":"TeacherClassesView_header__B-cv0"};